<template>
  <span :class="colorClass">{{ formatedValue ? formatedValue : rawValue }}</span>
</template>

<script>
export default {
  name: 'ColorIndicator',
  props: {
    rawValue: Number,
    formatedValue: [String, Number]
  },
  computed: {
    colorClass() {
      return {
        'green--text  text--darken-1' : this.rawValue > 0,
        'red--text' : this.rawValue < 0
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
